import { mapActions, mapGetters } from 'vuex';
import Empty from '@/components/@general/Empty/index.vue';
import OrderCard from '@/components/cards/OrderCard/index.vue';
import { globalLoader } from '@/helpers/variables';

export default {
  name: 'CurrentOrders',
  components: {
    Empty,
    OrderCard
  },
  data() {
    return {
      ordersList: [],
      currentPage: 1,
      isHasNextPage: false,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters({
      user: 'profile/user'
    })
  },
  created() {
    this.fetchInfo();
  },
  methods: {
    ...mapActions({
      getCurrentOrders: `profile/GET_CURRENT_ORDERS`
    }),
    fetchInfo() {
      this.isLoading = true;
      if (this.$route.query.order) {
        this.getCurrentOrdersUntilFound({
          page: this.currentPage,
          orderId: this.$route.query.order,
          perPage: 15
        });
      } else {
        this.getCurrentOrders({ page: this.currentPage, perPage: 15 }).then((res) => {
          this.ordersList = res.data;
          this.isHasNextPage = !!res.links.next;
          this.isLoading = false;
          globalLoader(false);
        });
      }
    },
    getCurrentOrdersUntilFound({ page, orderId }) {
      return this.getCurrentOrders({ page, perPage: 50 }).then((res) => {
        this.ordersList = this.ordersList ? [...this.ordersList, ...res.data] : res.data;
        this.isHasNextPage = !!res.links.next;
        const orderFound = this.ordersList.some((item) => item.id === orderId);

        if (this.isHasNextPage && !orderFound) {
          return this.getCurrentOrdersUntilFound({ page: page + 1, orderId, perPage: 50 });
        } else {
          this.isLoading = false;
          globalLoader(false);
        }
      });
    }
  }
};
